import * as React from 'react';
import { css } from '@emotion/react';
import { FadeLoader } from 'react-spinners';
import { Typography } from '@mui/material';

const override = css`
  display: block;
  margin: 0 auto;
  border-color: navy;
`;

interface Props {
  loading: boolean;
}

function Spinner(props: Props) {
  const { loading } = props;

  return (
    <div>
      <FadeLoader
        height={15}
        width={5}
        radius={2}
        margin={2}
        css={override}
        loading={loading}
      />
      {loading ? (
        <Typography align='center' variant='h6' component='h6' color='primary'>
          しばらくお待ち下さい...
        </Typography>
      ) : (
        ''
      )}
    </div>
  );
}

export default Spinner;
